import { render, staticRenderFns } from "./givingOutBenefits.vue?vue&type=template&id=0cacc3c0&scoped=true&"
import script from "./givingOutBenefits.vue?vue&type=script&lang=js&"
export * from "./givingOutBenefits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cacc3c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cacc3c0')) {
      api.createRecord('0cacc3c0', component.options)
    } else {
      api.reload('0cacc3c0', component.options)
    }
    module.hot.accept("./givingOutBenefits.vue?vue&type=template&id=0cacc3c0&scoped=true&", function () {
      api.rerender('0cacc3c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/welfareOperation/components/givingOutBenefits.vue"
export default component.exports